import React from "react";
import PickMeals from "../Assets/icon1.png";
import ChooseMeals from "../Assets/icon2.png";
import DeliveryMeals from "../Assets/icon3.png";
import Icno4 from "../Assets/icon5.png";
import Icno5 from "../Assets/icon4.png";

const Work = () => {
  const workInfoData = [
    {
      image: PickMeals,
      title: "Maintenance des équipements informatiques",
      text: "Assurez la performance et la longévité de vos équipements informatiques grâce à notre service de maintenance (ordinateurs, imprimantes/scanners, et réseaux)..",
    },
    {
      image: ChooseMeals,
      title: "Résolution des problèmes techniques (réseaux, caméras)",
      text: "Intervention rapide pour résoudre vos problèmes de connectivité, réseaux et caméras de surveillance, avec des solutions efficaces et fiables. ( pannes réseaux, caméras de surveillance, Wi-Fi et connectivité)",
    },
    {
      image: DeliveryMeals,
      title: "Amélioration du profil d’entreprise (affiches, logos, cartes de visite)",
      text: "Renforcez l’image de votre entreprise avec des créations visuelles pour une communication percutante. (Logo, carte visite personnalisées, affiches et bannières publicitaires)",
    },
    {
      image: Icno4,
      title: "Fourniture d’équipements",
      text: `
    Nous offrons une solution personnalisée pour la fourniture d'équipements adaptés à vos besoins spécifiques (Ordinateurs, imprimantes, accessoires, serveurs .  .  . ).
  `,
    },
    {
      image: Icno5,
      title: "Service de livraison rapide et fiable",
      text: `Profitez d’un service de livraison efficace et ponctuel, assurant la réception de vos équipements et fournitures en toute sécurité.
      <br/>
    Informatique : Ordinateurs, imprimantes, accessoires, serveurs, et tout autre matériel technologique.<br/>
    Quotidiens : Fournitures et équipements divers nécessaires à la bonne marche de vos opérations.`,
    },
  ];

  return (
    <div id="Service" className="bg-[#082028]  py-10 md:py-20"> {/* Updated background color */}
      <div className="container mx-auto px-6 md:px-12">
        {/* Top Section */}
        <div className="text-center p-3 shadow-md mb-12">
          <p className="text-[#D0B070] md:text-xl text-xs font-semibold mb-2"> {/* Updated text color */}
            Nos Services
          </p>
          <h1 className=" text-[#D0B070] md:text-6xl text-xl font-bold mb-4"> {/* Updated title color */}
            Nos Services Clés
          </h1>
          {/* <p className="text-gray-100 text-lg">
            Lorem ipsum dolor sit amet consectetur. Non tincidunt magna non et
            elit. Dolor turpis molestie dui magnis facilisis at fringilla quam.
          </p> */}
        </div>

        {/* Bottom Section */}
        <div className="grid grid-cols-1 pl-14 md:pl-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {workInfoData.map((data) => (
            <div
              key={data.title}
              className="relative w-[250px] md:w-[300px]  lg:w-[400px] lg:h-[550px] h-full bg-[#07182E] flex flex-col items-center justify-start rounded-[20px] overflow-hidden"
            >
              {/* Rotating Gradient Background */}
              <div className="absolute w-[150px] h-[150%] bg-gradient-to-b from-[#FFD700] to-[#FFFF00] animate-spin-slow"></div>

              {/* Inner Border */}
              <div className="absolute inset-[5px] bg-[#07182E] rounded-[20px]"></div>

              {/* Image Section */}
              <div className="relative z-10">
                <img
                  src={data.image}
                  alt={data.title}
                  className="object-cover bg-[#D0B070] md:h-36 h-14 bg-opacity-60 md:p-8 p-3 rounded-2xl"
                />
              </div>

              {/* Text Section */}
              <div className="relative z-10 p-6 text-center">
                <h2 className="text-[#D0B070] md:text-4xl text-[15px] font-bold mb-4"> {/* Updated title color */}
                  {data.title}
                </h2>
                <p
                  dangerouslySetInnerHTML={{ __html: data.text }}
                  className="text-gray-100 text-[9px] md:text-lg"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Work;
